
<template>
    <div>
      <b-navbar toggleable="lg" type="dark">
        <b-container>
            <b-navbar-brand :to="{ name: 'home' }" @click="closeMenu"><span>Mashup Web</span></b-navbar-brand>
            <b-navbar-toggle target="nav-collapse" v-on:click="toggleMenu"></b-navbar-toggle>
            <b-collapse id="nav-collapse" is-nav>
              <b-navbar-nav class="ml-auto">
                <b-nav-item :to="{ name: 'about' }" @click="closeMenu">{{ $t("home.nav.how-it-work") }}</b-nav-item>
                <b-nav-item :to="{ name: 'culture' }" @click="closeMenu">{{ $t("home.nav.culture") }}</b-nav-item>
                <b-nav-item class="logo"><b-navbar-brand :to="{ name: 'home' }" @click="closeMenu"><span>Mashup Web</span></b-navbar-brand></b-nav-item>
                <b-nav-item :to="{ name: 'contact' }" @click="closeMenu">{{ $t("home.nav.contact") }}</b-nav-item>
                <b-nav-text><LocalChanger @local-change="onChangeLocal"/></b-nav-text>
              </b-navbar-nav>
            </b-collapse>
          </b-container>
      </b-navbar>
    </div>  
</template>
<script>

import LocalChanger from './LocalChanger.vue'

export default {
  name: 'Navbar',
  components: {
      LocalChanger
  },
  methods: {
    onChangeLocal(value) {
      console.log("Navbar receive event lang : "+value)
      this.$emit('local-change', value)
    },
    toggleMenu: () => {
        console.log("toggle")
        document.body.querySelector("nav").classList.toggle("show-menu");
    },
    closeMenu: () => {
        console.log("close")
      document.body.querySelector("nav").classList.remove("show-menu")
    }
  }
}    
</script>

<style scoped>
    .navbar {
      font-weight: 600;
      font-size: 21px;

     /* position: fixed;
      width: 100%;
      left: 0;
      top: 0;
      background: red;
      z-index: 5;*/
    }
    .navbar.fixed {
      position: fixed;
      width: 100%;
      top: 0;
      left: 0;
    }
    .navbar>.container {
      padding: 0 25px;
    }
    a.navbar-brand {
        display: flex;
        background: url(../../assets/logo.svg) no-repeat;
        background-size: 100%;
        width: 114px;
        height: 43px;
    }
    a.navbar-brand span {
        display: none;
    }
    .navbar-toggler {
      padding: 0;
      border-radius: 0;
      border: 0;
      background: url(../../assets/menu-icon.svg) no-repeat;
      background-size: 100%;
      width: 29px;
      height: 24px;
    }
    .navbar-toggler[aria-expanded="true"] {
      background: url(../../assets/close-menu-icon.svg) no-repeat;
      background-size: 100%;
      height: 29px;
    }

    nav.show-menu {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100vh;
      z-index: 3;
      background: url(../../assets/menu-opened-header-mobile.svg) #1975ac no-repeat;
      background-size: 135% 140px;
      background-position: top center;
      display: block;
    }
    nav.show-menu a.navbar-brand {
      background: url(../../assets/logo-color.svg) no-repeat;
      background-size: 100%;
    }

    .navbar-collapse {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 100%;
      transform: translate(-50%, -50%);
      text-align: center;
    }
    @media (max-width: 980px){
      .navbar-collapse a {
          color: transparent !important;
      }
      nav.show-menu .navbar-collapse a {
          color: #fff !important;
      }
    }

    .navbar-nav li.logo {
      display: none;
    }
    
    
  /* desktop */
  @media (min-width: 992px){
    .navbar {
      font-weight: 500;
      font-size: 16px;
    }
    .navbar-nav {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }
    .navbar-expand-lg .navbar-collapse {
      line-height: 42px;
      padding: 0 20px;
    }
    .navbar-nav li.logo {
      display: block;
    }
    .navbar>.container>.navbar-brand {
      display: none;
    }
    .navbar-collapse {
      top: 0;
      transform: translate(-50%, 0);
    }
    
  }
</style>